/* eslint-disable object-shorthand */
/* eslint-disable camelcase */
import { sTrack } from 'src/utils/sensor';
import { isHK } from 'src/config/env';

const unknownText = '其他'; // [未知/其他/空值]

// 上报
/**
 * 页面曝光
 * @param {*} pageId
 */
export function trackActivityPageShow(pageId) {
	const event = isHK ? 'HS_Marketing_Page_Exposure' : 'activity_page_sw';
	sTrack(event, {
		page_id: pageId || unknownText,
	});
}

/**
 * 登录态访问页面
 * @param {*} pageId
 */
export function trackActivityPageView(pageId) {
	const event = isHK ? 'HS_Marketing_Page_View' : 'activity_page_view';
	sTrack(event, {
		page_id: pageId || unknownText,
	});
}

/**
 * 按钮点击
 * @param {*} pageId
 * @param {*} buttonName
 * @param {*} buttonId
 */
export function trackActivityPageClick(pageId, buttonName, buttonId) {
	const event = isHK ? 'HS_Marketing_Page_Button_Components_Click' : 'activity_page_click';
	sTrack(event, {
		[isHK ? 'button_components_name' : 'button_name']: buttonName || unknownText,
		page_id: pageId || unknownText,
		button_id: buttonId || unknownText,
	});
}

/**
 * 热区组件点击
 * @param {*} pageId
 * @param {*} hotspotName
 */
export function trackHotspotClick(pageId, hotspotName) {
	const event = isHK ? 'HS_Marketing_Page_Hotspot_Components_Click' : 'Hotspot_Components_Click';
	sTrack(event, {
		page_id: pageId || unknownText,
		hotspot_name: hotspotName || unknownText,
	});
}

/**
 * 吸底按钮点击
 * @param {*} pageId
 */
export function trackfixedButtonClick(pageId) {
	const event = isHK
		? 'HS_Marketing_Page_Bottom_Suction_Button_Components_Click'
		: 'Bottom_Suction_Button_Components_Click';
	sTrack(event, {
		page_id: pageId || unknownText,
	});
}

/**
 * 卡券组件曝光
 * @param {*} pageId
 * @param {*} couponsComponentsName
 */
export function trackCouponsView(pageId, couponsComponentsName) {
	const event = isHK
		? 'HS_Marketing_Page_Coupons_Components_Exposure'
		: 'Coupons_Components_Exposure';
	sTrack(event, {
		page_id: pageId || unknownText,
		coupons_components_name: couponsComponentsName || unknownText,
	});
}

/**
 * 卡券组件点击
 * @param {*} pageId
 * @param {*} couponsComponentsName
 * @param {*} getResults
 */
export function trackCouponsClick(pageId, couponsComponentsName, getResults) {
	const event = isHK ? 'HS_Marketing_Page_Coupons_Components_Click' : 'Coupons_Components_Click';
	sTrack(event, {
		page_id: pageId || unknownText,
		coupons_components_name: couponsComponentsName || unknownText,
		get_results: getResults || unknownText,
	});
}

/**
 * 登录注册组件跳转
 * @param {*} pageId
 */
export function trackActivityLoginClick(pageId) {
	sTrack('activity_login_component_click', {
		page_id: pageId || unknownText,
	});
}

/**
 * 兑换码组件访问
 * @param {*} pageId
 */
export function trackRedeemCompView() {
	sTrack('Password_red_envelope_exposed', {});
}

/**
 * 兑换码组件按钮点击
 * @param {*} pageId
 */
export function trackRedeemBtnClick() {
	sTrack('Click_Password_Red_Envelope_Button', {});
}

/**
 * 股票组件展示
 */
export function trackStockCompView(params) {
	sTrack('HS_Marketing_Page_Stock Components_Exposure', params);
}

/**
 * 股票组件点击
 */
export function trackStockClick(params) {
	sTrack('HS_Marketing_Page_Stock Components_Click', params);
}

/**
 * 资讯组件点击
 */
export function trackNewsClick(params) {
	sTrack('HS_Marketing_Page_News Components_Click', params);
}
